var d = Object.defineProperty;
var g = (e, s, r) => s in e ? d(e, s, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[s] = r;
var c = (e, s, r) => (g(e, typeof s != "symbol" ? s + "" : s, r), r);
var h = /* @__PURE__ */ ((e) => (e[e.DEBUG = 0] = "DEBUG", e[e.INFO = 1] = "INFO", e[e.WARN = 2] = "WARN", e[e.ERROR = 3] = "ERROR", e[e.OFF = 4] = "OFF", e))(h || {});
const i = "[dom-event-bus]", o = 3, b = {
  logLevel: o,
  setLogLevel: (e = o) => {
    b.logLevel = e;
  },
  debug: (e, ...s) => {
    b.logLevel < 1 && console.debug(i, e, s);
  },
  info: (e, ...s) => {
    b.logLevel < 2 && console.info(i, e, s);
  },
  warn: (e, ...s) => {
    b.logLevel < 3 && console.warn(i, e, s);
  },
  error: (e, ...s) => {
    b.logLevel < 4 && console.error(i, e, s);
  }
}, l = ["__proto__", "constructor", "prototype"];
class t {
  constructor() {
    c(this, "subscribeMap", {});
  }
  static getInstance() {
    if (!globalThis.eventbus) {
      const s = new t();
      globalThis.eventbus = s, Object.freeze(s);
    }
    return globalThis.eventbus;
  }
  publish(s, r) {
    b.debug("publishing to", s, r);
    const n = this.subscribeMap[s];
    if (!n)
      return;
    const u = Object.keys(n);
    u.forEach((a) => {
      n[a](r);
    }), b.debug("published", s, "to", u);
  }
  subscribe(s, r, n) {
    if (b.debug("subscribing to", s), l.includes(s) || n && l.includes(n))
      return b.debug("invalid id name used while subscribing to", s), () => {
      };
    const u = n ?? globalThis.crypto.randomUUID();
    return this.subscribeMap[s] || (this.subscribeMap[s] = {}), this.subscribeMap[s][u] = r, b.debug("subscribed to", s, "with id", u), () => this.unsubscribe(u, s);
  }
  unsubscribe(s, r) {
    b.debug("unsubscribing from", r);
    const n = this.subscribeMap[r];
    n && (delete n[s], b.debug("unsubscribed to", r));
  }
}
function E(e, s, r) {
  try {
    return t.getInstance().subscribe(e, s, r);
  } catch (n) {
    b.error(n);
  }
}
function O(e, s) {
  try {
    return t.getInstance().unsubscribe(s, e);
  } catch (r) {
    b.error(r);
  }
}
function R(e, s) {
  try {
    return t.getInstance().publish(e, s);
  } catch (r) {
    b.error(r);
  }
}
const { setLogLevel: F } = b;
export {
  h as LogLevel,
  R as publish,
  F as setLogLevel,
  E as subscribe,
  O as unsubscribe
};
